import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface SubscriptionRestrictedProps {
  featureName: string;
}

/**
 * Shown in place of a feature when the current partner's subscription is not
 * active, informing them what is required to regain access.
 */
export default function SubscriptionRestricted({
  featureName,
}: SubscriptionRestrictedProps) {
  return (
    <Container
      sx={{
        marginTop: '75px !important',
        width: '100%',
        padding: '0px 15px !important',
      }}
    >
      <Box
        sx={{
          p: 4,
          textAlign: 'center',
          border: '1px solid #eee',
          borderRadius: 2,
          bgcolor: '#fafafa',
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 48, color: '#dd8709', mb: 1 }} />
        <Typography
          variant="h6"
          sx={{ fontFamily: 'GFS Didot', fontWeight: 'bold', mb: 1 }}
        >
          {featureName} is not available
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
          Your subscription is not currently active. Please subscribe or renew
          your plan to access {featureName.toLowerCase()}.
        </Typography>
        <Button
          variant="contained"
          href="/subscription-details"
          sx={{
            bgcolor: '#dd8709',
            fontFamily: 'GFS Didot',
            fontWeight: 'bold',
            '&:hover': { bgcolor: '#b86e08' },
          }}
        >
          View Subscription
        </Button>
      </Box>
    </Container>
  );
}
